<template>

</template>

<script>
  import Vue from 'vue'
  import VTooltip from 'v-tooltip'

  Vue.use(VTooltip);

  export default {}
</script>

<style lang="scss">
  .tooltip {
    display: block !important;
    z-index: 10000;

    .tooltip-inner {
      background: black;
      color: white;
      padding: 5px 10px 4px;
    }

    .tooltip-arrow {
      width: 0;
      height: 0;
      border-style: solid;
      position: absolute;
      margin: 5px;
      border-color: black;
      z-index: 1;

      &:before {
        content: "";
        position: absolute;
        width: 20px;
        height: 20px;
        transform: rotate(45deg);
        background: #fff;
      }
    }

    &[x-placement^="top"] {
      margin-bottom: 5px;

      .tooltip-arrow {
        border-width: 5px 5px 0 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        bottom: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0;
      }
    }

    &[x-placement^="bottom"] {
      margin-top: 5px;

      .tooltip-arrow {
        border-width: 0 5px 5px 5px;
        border-left-color: transparent !important;
        border-right-color: transparent !important;
        border-top-color: transparent !important;
        top: -5px;
        left: calc(50% - 5px);
        margin-top: 0;
        margin-bottom: 0
      }
    }

    &[x-placement^="right"] {
      margin-left: 5px;

      .tooltip-arrow {
        overflow: hidden;
        width: 20px;
        height: 20px;
        left: -37px;

        &:before {
          left: 22px;
          top: calc(50% - 10px);
          box-shadow: -4px 4px 10px -4px rgba(0, 0, 0, 0.5);
        }
      }
    }

    &[x-placement^="left"] {
      margin-right: 5px;

      .tooltip-arrow {
        border-width: 5px 0 5px 5px;
        border-top-color: transparent !important;
        border-right-color: transparent !important;
        border-bottom-color: transparent !important;
        right: -5px;
        top: calc(50% - 5px);
        margin-left: 0;
        margin-right: 0;
      }
    }

    &.popover {
      $color: #ffffff;
      border: none;

      .popover-inner {
        background: $color;
        color: black;
        padding: 18px;
        box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);
        max-width: 500px;
        max-height: 70vh;
        overflow: auto;
      }

      .popover-arrow {
        z-index: 1;
        width: 32px;
        height: 32px;
        border: none;
      }
    }

    &[aria-hidden='true'] {
      visibility: hidden;
      opacity: 0;
      transition: opacity .15s, visibility .15s;
    }

    &.open {
      visibility: visible;
      opacity: 1;
      transition: opacity .15s;
    }
  }
</style>
